import {
	CONST_INSTRUCTED,
	CONST_EQUIVALENT,
	CONST_GBP_EQUIVALENT,
	CONST_AMOUNT_UPPERCASE,
} from '../../../src/constants/Constants';
import { TYPE_IFT, fxRatesType } from '../../../src/config';
import { hardTokenLiveRateVerification } from './ift/verifications/hard-token-live-rate';

export const iftVerificationAll = [
	...hardTokenLiveRateVerification,
	{
		verification_id: '20037855-f07c-4298-80c6-9f5a9a5e978568ea', // uuid to identify new verification record
		status: 'CHALLENGE',
		created_timestamp: '2015-08-05T00:00:00.000Z',
		final_approval: false, // optional
		verification_type: 'HARD',
		ift: {
			payment_uuid: '20037855-f07c-4298-80c6-9f5a9a5e978568ea',
			type: TYPE_IFT,
			amount: '550.00',
			currency: 'GBP',
			debtor_currency: 'GBP',
			creditor_currency: 'EUR',
			creator_id: '0112341234',
			creator_name: 'John Smith',
			payment_amount: [
				{
					type: CONST_INSTRUCTED,
					value: '200.20',
					currency: 'EUR',
				},
				{
					type: CONST_EQUIVALENT,
					value: '100.20',
					currency: 'GBP',
				},
				{
					type: CONST_GBP_EQUIVALENT,
					value: '200.20',
					currency: 'EUR',
				},
			],
			approvers: [
				{
					approver: 'Joe Bloggs',
					status: 'PENDING',
				},
				{
					approver: 'Christopher Sutton',
					status: 'VERIFIED',
				},
			],
			from_account: {
				account_number: '12345678',
				name: 'SIMON DAY1', // Currently sent as null
				sort_code: '822000', // Optional for Kapiti accounts
			},
			to_account: {
				account_number: '1234567890123456789012345678901234', // will either get this or iban
				iban: '1234567890123456789012345678901234', // 34 alphanumeric, will either get this or target_account
				name: 'SIMONDAY11SIMONDAY11', // Currently sent as null
				bic: '', // optional, will either get this or bank when user sends target_account
				bank: {
					// optional, will either get this or bic when user sends target_account
					name: '',
					address: {
						address_line_1: '',
						address_line_2: '',
						city: '',
						postal_code: '',
						country: '',
					},
				},
				beneficiary_address: {
					// payee customer address
					address_line_1: '',
					address_line_2: '',
					city: '',
					postal_code: '',
					country: '',
				},
				clearing_code: '', // optional
			},

			reference: 'Pre Booked Payment Reference', // optional
			value_date: '2017-01-08',
			submission_date: '2017-01-05',
			urgent: true,
			charging_model: 'CRED', // optional
			indicative_fx: {
				rate: '0.8455',
				type: fxRatesType.PRE_BOOKED_RATE,
			},
			charge_amount: [
				{
					type: CONST_AMOUNT_UPPERCASE,
					value: '200.20',
					currency: 'EUR',
				},
				{
					// only when non GBP amount
					type: CONST_GBP_EQUIVALENT,
					value: '200.20',
					currency: 'GBP',
				},
			],
		},
	},
	{
		verification_id: '20037855-f07c-4298-80568ea', // uuid to identify new verification record
		status: 'PENDING',
		created_timestamp: '2015-08-05T00:00:00.000Z',
		final_approval: true,
		verification_type: 'HARD',
		ift: {
			payment_uuid: '20037855-f07c-4298-80568ea',
			type: TYPE_IFT,
			amount: '550.00',
			currency: 'GBP',
			debtor_currency: 'GBP',
			creditor_currency: 'EUR',
			creator_id: '0112341234',
			creator_name: 'John Smith',
			payment_amount: [
				{
					type: CONST_INSTRUCTED,
					value: '200.20',
					currency: 'EUR',
				},
				{
					type: CONST_GBP_EQUIVALENT,
					value: '200.20',
					currency: 'GBP',
				},
			],
			approvers: [
				{
					approver: 'Joe Bloggs',
					status: 'PENDING',
				},
				{
					approver: 'Christopher Sutton',
					status: 'VERIFIED',
				},
			],
			from_account: {
				account_number: '12345678',
				name: 'SIMON DAY', // Currently sent as null
				sort_code: '822000', // Optional for Kapiti accounts
			},
			to_account: {
				account_number: '1234567890123456789012345678901234', // will either get this or iban
				iban: '1234567890123456789012345678901234', // 34 alphanumeric, will either get this or target_account
				name: 'SIMON DAY', // Currently sent as null
				bic: '', // optional, will either get this or bank when user sends target_account
				bank: {
					// optional, will either get this or bic when user sends target_account
					name: '',
					address: {
						address_line_1: '',
						address_line_2: '',
						city: '',
						postal_code: '',
						country: '',
					},
				},
				beneficiary_address: {
					// payee customer address
					address_line_1: '',
					address_line_2: '',
					city: '',
					postal_code: '',
					country: '',
				},
				clearing_code: '', // optional
			},

			reference: 'Live Rate', // optional
			value_date: '2017-01-08',
			submission_date: '2017-01-05',
			urgent: true,
			charging_model: 'SHAR', // optional
			indicative_fx: {
				rate: '0.8455',
				type: 'LIVE',
			},
			charge_amount: [
				{
					type: CONST_AMOUNT_UPPERCASE,
					value: '10.20',
					currency: 'EUR',
				},
				{
					// only when non GBP amount
					type: CONST_GBP_EQUIVALENT,
					value: '20.20',
					currency: 'GBP',
				},
			],
		},
	},
	{
		verification_id: '20037855-f07c-4298-8056efrwfwefe8ea', // uuid to identify new verification record
		status: 'PENDING',
		created_timestamp: '2015-08-05T00:00:00.000Z',
		final_approval: false,
		verification_type: 'HARD',
		ift: {
			payment_uuid: '20037855-f07c-4298-8056efrwfwefe8ea',
			type: TYPE_IFT,
			amount: '550.00',
			currency: 'GBP',
			debtor_currency: 'GBP',
			creditor_currency: 'EUR',
			creator_id: '0112341234',
			creator_name: 'John Smith',
			payment_amount: [
				{
					type: CONST_INSTRUCTED,
					value: '200.20',
					currency: 'EUR',
				},
				{
					type: CONST_GBP_EQUIVALENT,
					value: '200.20',
					currency: 'GBP',
				},
			],
			approvers: [
				{
					approver: 'Joe Bloggs',
					status: 'PENDING',
				},
				{
					approver: 'Christopher Sutton',
					status: 'VERIFIED',
				},
			],
			from_account: {
				account_number: '12345678',
				name: 'SIMON DAY', // Currently sent as null
				sort_code: '822000', // Optional for Kapiti accounts
			},
			to_account: {
				account_number: '1234567890123456789012345678901234', // will either get this or iban
				iban: '1234567890123456789012345678901234', // 34 alphanumeric, will either get this or target_account
				name: 'SIMON DAY', // Currently sent as null
				bic: '', // optional, will either get this or bank when user sends target_account
				bank: {
					// optional, will either get this or bic when user sends target_account
					name: '',
					address: {
						address_line_1: '',
						address_line_2: '',
						city: '',
						postal_code: '',
						country: '',
					},
				},
				beneficiary_address: {
					// payee customer address
					address_line_1: '',
					address_line_2: '',
					city: '',
					postal_code: '',
					country: '',
				},
				clearing_code: '', // optional
			},

			reference: 'Indicative Rate', // optional
			value_date: '2017-01-08',
			submission_date: '2017-01-05',
			urgent: true,
			charging_model: 'SHAR', // optional
			indicative_fx: {
				rate: '0.8455',
				type: 'SHEET',
			},
			charge_amount: [
				{
					type: CONST_AMOUNT_UPPERCASE,
					value: '10.20',
					currency: 'EUR',
				},
				{
					// only when non GBP amount
					type: CONST_GBP_EQUIVALENT,
					value: '20.20',
					currency: 'GBP',
				},
			],
		},
	},
	{
		verification_id: '20037855-f07c-4lfksglkl34554k',
		status: 'PENDING',
		created_timestamp: '2015-08-05T00:00:00.000Z',
		final_approval: 'false',
		verification_type: 'SOFT',
		ift: {
			payment_uuid: '20037855-f07c-4298-80c6-9f5a9a5e443966a',
			type: TYPE_IFT,
			amount: '1550.00',
			currency: 'GBP',
			debtor_currency: 'GBP',
			creditor_currency: 'EUR',
			creator_id: '0112341234',
			creator_name: 'John Smith',
			payment_amount: [
				{
					type: CONST_INSTRUCTED,
					value: '1200.20',
					currency: 'EUR',
				},
				{
					type: CONST_EQUIVALENT,
					value: '2100.20',
					currency: 'GBP',
				},
				{
					type: CONST_GBP_EQUIVALENT,
					value: '200.20',
					currency: 'EUR',
				},
			],
			approvers: [
				{
					approver: 'Joe Bloggs',
					status: 'PENDING',
				},
				{
					approver: 'Christopher Sutton',
					status: 'VERIFIED',
				},
			],
			from_account: {
				account_number: '50017756334563546',
				name: 'From  Account',
			},
			to_account: {
				iban: '1234567890123456789012345678901234', // 34 alphanumeric, will either get this or target_account
				name: 'SIMON DAY', // Currently sent as null
				bic: '', // optional, will either get this or bank when user sends target_account
				bank: {
					// optional, will either get this or bic when user sends target_account
					name: '',
					address: {
						address_line_1: '',
						address_line_2: '',
						city: '',
						postal_code: '',
						country: '',
					},
				},
				beneficiary_address: {
					// payee customer address
					address_line_1: '',
					address_line_2: '',
					city: '',
					postal_code: '',
					country: '',
				},
				clearing_code: '', // optional
			},
			reference: 'Payment Reference Hard Token', // optional
			value_date: '2017-01-15',
			submission_date: '2017-01-04',
			urgent: true,
			charging_model: 'CRED',
			indicative_fx: {
				rate: '0.8455',
				type: fxRatesType.PRE_BOOKED_RATE,
			},
			charge_amount: [
				{
					type: CONST_AMOUNT_UPPERCASE,
					value: '200.20',
					currency: 'EUR',
				},
				{
					// only when non GBP amount
					type: CONST_GBP_EQUIVALENT,
					value: '200.20',
					currency: 'EUR',
				},
			],
		},
	},
];

export const approveIFTOthers = [
	{
		type: TYPE_IFT,
		id: 'ift-by-another-tab',
		last_updated_on: '2017-01-02T12:24:00.000Z',
		reference: 'IFT By Another payment',
		status: 'Awaiting Authorisation',
		result_code: '1234',
		created_by: 'John Smith',
		debtor_currency: 'GBP',
		creditor_currency: 'EUR',
		payment_amount: [
			{
				type: CONST_INSTRUCTED,
				value: '200.20',
				currency: 'EUR',
			},
			{
				type: CONST_EQUIVALENT,
				value: '1200.20',
				currency: 'GBP',
			},
			{
				type: CONST_GBP_EQUIVALENT,
				value: '200.20',
				currency: 'EUR',
			},
		],
		from_account: {
			account_number: '50017756',
			sort_code: '826817',
			name: 'IFT Account',
			currency: 'GBP',
		},
		to_account: {
			name: 'IFT Beneficiary',
			iban: '498938294989382949893829',
			bic: '', // optional
			clearing_code: '', // optional
			bank_name: '', // optional
			bank_country: '', // optional
		},
		approvers: [
			{
				approver: 'Joe Bloggs',
				status: 'PENDING',
			},
			{
				approver: 'Christopher Sutton',
				status: 'VERIFIED',
			},
		],
		value_date: '2017-01-15',
		submission_date: '2017-01-04',
		indicative_fx: {
			rate: '0.8455',
			type: fxRatesType.PRE_BOOKED_RATE,
		},
		charging_model: 'SHAR',
		charge_amount: [
			{
				type: CONST_AMOUNT_UPPERCASE,
				value: '20.20',
				currency: 'EUR',
			},
			{
				// only when non GBP amount
				type: CONST_GBP_EQUIVALENT,
				value: '20.20',
				currency: 'EUR',
			},
		],
	},
	{
		id: '641b4930-3225-11ea-9eff-457b5ee24e6a',
		last_updated_on: '2020-01-08T14:49:06.919Z',
		reference: 'IFT Verified',
		status: 'PENDING',
		created_by: 'AdditionalUserOne BRIN',
		payment_amount: [
			{
				value: 3,
				currency: 'GBP',
				type: 'INSTRUCTED',
			},
			{
				value: 3,
				currency: 'GBP',
				type: 'EQUIVALENT',
			},
		],
		from_account: {
			account_number: '60016073',
			name: 'IKWABEDVRS KRGQOKV',
			sort_code: '823000',
			currency: 'GBP',
		},
		to_account: {
			account_number: 'GB64CLYD82300030017029',
			name: 'GBP PAYEE',
			bank: {
				address: {
					country: 'GB',
				},
			},
			beneficiary_address: {
				city: 'Glasgow',
				country: 'GB',
				address_line_1: '1/9 240 Wallace street',
			},
		},
		approvers: [
			{
				status: 'VERIFIED',
				approver: 'V R FrY ',
			},
			{
				status: 'PENDING',
				approver: 'VJ BRIN',
			},
		],
		value_date: '2020-01-08',
		debtor_currency: 'GBP',
		creditor_currency: 'GBP',
		charging_model: 'SHAR',
		charge_amount: [
			{
				value: 5.05,
				currency: 'GBP',
				type: 'AMOUNT',
			},
			{
				value: 5.05,
				currency: 'GBP',
				type: 'GBP_EQUIVALENT',
			},
		],
		indicative_fx: {
			rate: 1,
			type: 'LIVE_RATE',
		},
		created_timestamp: '2020-01-08T14:45:21.439Z',
		creator_id: '9000208869',
		submission_date: '2020-01-08',
		urgent: true,
	},
];
